import type { Plugin } from 'vue';
import { ColorPickerV3 as TKColorPickerV3 } from './components/color-picker-v3';
import { Background as TKBackground } from './components/background';
import { PhotoList as TKPhotoList } from './components/photo-list';
import { Gallery as TKGallery } from './components/gallery';

export default [TKColorPickerV3, TKBackground, TKPhotoList, TKGallery] as Plugin[];
